// Pure helper to fetch a CSV and extract filename from Content-Disposition
export async function exportCsv({
  locationPath,
  searchParams,
  headers = { 'Content-Type': 'text/csv', Accept: 'text/csv' },
  signal,
} = {}) {
  if (!locationPath) throw new Error('locationPath required')

  const url = `${locationPath}?${searchParams}`
  const response = await fetch(url, { headers, signal })

  // Some test mocks may omit `ok`; treat only explicit false as an error
  if (response.ok === false) {
    const text = await response.text().catch(() => '')
    const err = new Error(`Export failed: ${response.status}`)
    err.status = response.status
    err.body = text
    throw err
  }

  const contentDisposition = response.headers.get('Content-Disposition') || ''

  // Try RFC5987 filename*= encoding first
  let filename = 'export.csv'
  const filenameStarMatch = contentDisposition.match(/filename\*=(?:UTF-8'')?([^;\n]+)/i)
  if (filenameStarMatch?.[1]) {
    try {
      filename = decodeURIComponent(filenameStarMatch[1].trim())
    } catch (_e) {
      filename = filenameStarMatch[1].trim()
    }
  } else {
    // Fallback to filename="..." or filename=...
    const match = contentDisposition.match(/filename\s*=\s*"?([^";]+)"?/i)
    if (match?.[1]) {
      filename = match[1].trim()
    }
  }

  const blob = await response.blob()
  return { blob, filename }
}

export default exportCsv
